module.exports = __webpack_public_path__ + "fonts/fb754dec-aa8f-444c-be48-868464c47ab0.b28aa1f3.woff";